import { createRouter,createWebHashHistory} from "vue-router";
import {setCookie} from '@/api/plcore'

export const constantRoutes = [
    {
        path: '/mode-view',
        component: ()=>import('@/views/light/mode-view')
    },
	{
	    path: '/mode-addV3',
	    component: ()=>import('@/views/light/spl-022ct/mode-addV3')
	},
    {
        path: '/mode-addV2',
        component: ()=>import('@/views/light/spl-041b/mode-addV2')
    },
	{
	    path: '/mode-add',
	    component: ()=>import('@/views/light/mode-add')
	},
    {
        path: '/all-comps',
        component: ()=>import('@/views/all-comps')
    },
    {
        path: '/all-selectors',
        component: ()=>import('@/views/all-selectors')
    },
    {
        path: '/SPL-031C',
        component: ()=>import('@/views/light/spl-031c/App'),
        redirect:'/SPL-031C/index',
        children:[
            {
                path: 'index',
                component: ()=>import('@/views/light/spl-031c/ControlPage')
            },
            {
                path: 'mode-view',
                component: ()=>import('@/views/light/spl-031c/SceneModeList')
            },
            {
                path: 'settings',
                component: ()=>import('@/views/light/spl-031c/SettingPage')
            }
        ]
    },
    {
        path: '/SPL-032C',
        component: ()=>import('@/views/light/spl-032c/App'),
        redirect:'/SPL-032C/index',
        children:[
            {
                path: 'index',
                component: ()=>import('@/views/light/spl-032c/ControlPage')
            },
            {
                path: 'mode-view',
                component: ()=>import('@/views/light/spl-032c/SceneModeList')
            },
            {
                path: 'settings',
                component: ()=>import('@/views/light/spl-032c/SettingPage')
            }
        ]
    },
    {
        // 室外能耗传感器
        path:'/SPD-040A',
        component: ()=>import('@/views/sensor/spd-040a')
    },
	{
	    // 室内能耗传感器
	    path:'/SPD-040B',
	    component: ()=>import('@/views/sensor/spd-040a')
	},
	{
		path:'/SPD-036A',
		component: ()=>import('@/views/sensor/spd-036ab')
	},
	{
		path:'/SPD-036B',
		component: ()=>import('@/views/sensor/spd-036ab')
	},
    {
        // 恒流型LED控制器,RGB
        path: '/SPL-013A',
        component: ()=>import('@/views/light/spl-013a013b/App'),
        children:[
            {
                path: 'index',
                component: ()=>import('@/views/light/spl-013a013b/Control')
            },
            {
                path: 'mode-view',
                component: ()=>import('@/views/light/spl-013a013b/SceneModeList')
            },
            {
                path: 'device',
                component: ()=>import('@/views/light/spl-013a013b/Settings')
            }
        ]
    },
    {
        // 恒流型LED控制器,RGB
        path: '/SPL-013B',
        component: ()=>import('@/views/light/spl-013a013b/App'),
        redirect:'/SPL-013B/index',
        children:[
            {
                path: 'index',
                component: ()=>import('@/views/light/spl-013a013b/Control')
            },
            {
                path: 'mode-view',
                component: ()=>import('@/views/light/spl-013a013b/SceneModeList')
            },
            {
                path: 'device',
                component: ()=>import('@/views/light/spl-013a013b/Settings')
            }
        ]
    },
    {
        // 恒压型LED控制器,RGB调光调色
        path: '/SPL-023A',
        component: ()=>import('@/views/light/spl-023a023b/App'),
        redirect:'/SPL-023A/index',
        children:[
            {
                path: 'index',
                component: ()=>import('@/views/light/spl-023a023b/Control')
            },
            {
                path: 'mode-view',
                component: ()=>import('@/views/light/spl-023a023b/SceneModeList')
            },
            {
                path: 'settings',
                component: ()=>import('@/views/light/spl-023a023b/Settings')
            }
        ]
    },
    {
        // 恒压型LED控制器,RGB调光调色
        path: '/SPL-023B',
        component: ()=>import('@/views/light/spl-023a023b/App'),
        redirect:'/SPL-023B/index',
        children:[
            {
                path: 'index',
                component: ()=>import('@/views/light/spl-023a023b/Control')
            },
            {
                path: 'mode-view',
                component: ()=>import('@/views/light/spl-023a023b/SceneModeList')
            },
            {
                path: 'settings',
                component: ()=>import('@/views/light/spl-023a023b/Settings')
            }
        ]
    },
    {
        // 恒压型LED灯带控制器,开关+RGB调光调色
        path: '/SPL-025A',
        component: ()=>import('@/views/light/spl-025a025b/App'),
        redirect:'/SPL-025A/index',
        children:[
            {
                path: 'index',
                component: ()=>import('@/views/light/spl-025a025b/Control')
            },
            {
                path: 'mode-view',
                component: ()=>import('@/views/light/mode-view')
            },
            {
                path: 'device',
                component: ()=>import('@/views/light/spl-025a025b/Settings')
            }
        ]
    },
	{
	    // 恒压型LED灯带控制器,开关+RGB调光调色
	    path: '/SPL-041B',
	    component: ()=>import('@/views/light/spl-041b/App'),
	    redirect:'/SPL-041B/index',
	    children:[
	        {
	            path: 'index',
	            component: ()=>import('@/views/light/spl-041b/Control')
	        },
	        {
	            path: 'mode-view',
	            component: ()=>import('@/views/light/spl-041b/mode-view')
	        },
	        {
	            path: 'set',
	            component: ()=>import('@/views/light/spl-041b/Settings')
	        }
	    ]
	},
	{
	    // 两线全色温控制器,开关+拓展色温+拓展亮度+情景模式v3版
	    path: '/SPL-022CT',
	    component: ()=>import('@/views/light/spl-022ct/App'),
	    redirect:'/SPL-022CT/index',
	    children:[
	        {
	            path: 'index',
	            component: ()=>import('@/views/light/spl-022ct/Control')
	        },
	        {
	            path: 'mode-view',
	            component: ()=>import('@/views/light/spl-022ct/mode-view')
	        }
	    ]
	},
	{
	    // SGL-031A SGL-031C
	    path: '/SGL-031A',
	    component: ()=>import('@/views/light/sgl-031a/Control'),
	},
    {
        // 恒压型LED灯带控制器,开关+RGB调光调色
        path: '/SPL-025B',
        component: ()=>import('@/views/light/spl-025a025b/App'),
        redirect:'/SPL-025B/index',
        children:[
            {
                path: 'index',
                component: ()=>import('@/views/light/spl-025a025b/Control')
            },
            {
                path: 'mode-view',
                component: ()=>import('@/views/light/mode-view')
            },
            {
                path: 'device',
                component: ()=>import('@/views/light/spl-025a025b/Settings')
            }
        ]
    },
    {
        // 恒流型LED控制器,RGB
        path: '/SPL-033C',
        component: ()=>import('@/views/light/spl-033c/App'),
        children:[
            {
                path: 'index',
                component: ()=>import('@/views/light/spl-033c/Control')
            },
            {
                path: 'mode-view',
                component: ()=>import('@/views/light/spl-013a013b/SceneModeList')
            },
            {
                path: 'settings',
                component: ()=>import('@/views/light/spl-033c/SettingPanel')
            }
        ]
    },
    
    {
        path: '/',
        component: ()=>import("@/layout/index.vue"),
        children:[
            {
                // 燃气传感器 SPD-014A
                path:'SPD-014A',
                component: ()=>import('@/views/sensor/gas-sensor'),
            },
            {
                // 燃气传感器 SPD-031A
                path:'SPD-031A',
                component: ()=>import('@/views/sensor/gas-sensor'),
            },
            {
                // 烟雾传感器
                path:'SPD-015A',
                component: ()=>import('@/views/sensor/gas-sensor'),
            },
            {
                // 烟雾传感器
                path:'SPD-032A',
                component: ()=>import('@/views/sensor/gas-sensor'),
            },
            {
                // 空气传感器
                path:'SPD-060A',
                component: ()=>import('@/views/sensor/air-sensor'),
            },
            {
                // 存在照度传感器
                path:'SPD-024A',
                component: ()=>import('@/views/sensor/existence-sensor')
            },
            {
                // 风雨传感器
                path:'SPD-016A',
                component: ()=>import('@/views/sensor/natural-sensor')
            },
            {
                // 风雨传感器
                path:'SPD-033A',
                component: ()=>import('@/views/sensor/natural-sensor')
            },
            {
                // 声光传感器
                path:'SPC-010A',
                component: ()=>import('@/views/sensor/natural-sensor')
            },
            {
                // 门磁传感器
                path:'SPD-011A',
                component: ()=>import('@/views/sensor/alarm-sensor')
            },
			{
                // 水浸传感器
                path:'SPD-013A',
                component: ()=>import('@/views/sensor/alarm-sensor')
            },
            {
                // 户外红外照度传感器
                path:'SPD-010A',
                component: ()=>import('@/views/sensor/ir-sensor')
            },
			{
			    // 室内红外照度传感器
			    path:'SPD-010B',
			    component: ()=>import('@/views/sensor/ir-sensor')
			},
            {
                // 室外微波照度传感器
                path:'SPD-030A',
                component: ()=>import('@/views/sensor/microwave-sensor')
            },
			{
			    // 室内微波照度传感器
			    path:'SPD-030B',
			    component: ()=>import('@/views/sensor/microwave-sensor')
			},
            {
                // 老人房求助面板
                path:'SPD-012A',
                component: ()=>import('@/views/panel/old-help-panel')
            },
            {
                path:':pathMatch(.*)*',
                component: ()=> import('@/views/custom-view')
            }
        ],
    },
    {
        path: '/default',
        component: ()=>import('@/views/default-view'),
    },
    {
        path: '/',
        component: ()=>import("@/layout/index.vue")
    },
    // {
    //     path: '/:pathMatch(.*)*',
    //     redirect: '/',
    // }
]

export const gatewayRoute = [
    {
        path: '/',
        component: ()=>import("@/layout/index.vue"),
        children:[
            {
                path: 'SPG-011A',
                component: ()=>import('@/views/gateway/gateway-view')
            },
            {
                path: 'SPG-021A',
                component: ()=>import('@/views/gateway/gateway-view')
            }
        ]
    }
]

export const controllerRoute = [
    {
        path: '/',
        component: ()=>import("@/layout/index.vue"),
        children:[
            {
                // 单轨道窗帘电机
                path: '/SPC-031A/horizontal_curtains',
                component: ()=>import('@/views/controller/curtain-rail')
            },
            {
                // 单轨道窗帘电机
                path: '/SPC-031A/vertical_curtains',
				component: ()=>import('@/views/controller/spc-031aa')
            },
            {
                // 单轨道窗帘电机
                path: '/SPC-031A',
                component: ()=>import('@/views/controller/curtain-rail')
            },
			{
			    // 单轨道窗帘电机
			    path: '/SPC-031B',
			    component: ()=>import('@/views/controller/curtain-rail')
			},
			
            {
                // 双轨道窗帘电机
                path: '/SPC-032A',
                component: ()=>import('@/views/controller/spc-032a')
            },
			{
			    // 双轨道窗帘电机
			    path: '/SPC-032B',
			    component: ()=>import('@/views/controller/spc-032a')
			},
            {
                // 单臂开窗器
                path: '/SPC-030A',
                component: ()=>import('@/views/controller/window-executor')
            },
			{
			    // 开窗器
			    path: '/SPC-030B',
			    component: ()=>import('@/views/controller/window-executor')
			},
			
            {
                // 阀门机械手
                path: '/SPC-011A',
                component: ()=>import('@/views/controller/valve-default')
            },
        ]
    }
    
]

export const panelRoute = [
    {
        // 开关面板
        path: '/SPS-011A',
        component: ()=>import('@/views/panel/switch-panel-setting')
    },
	{
	    // 开关面板
	    path: '/SPS-011B',
	    component: ()=>import('@/views/panel/switch-panel-setting')
	},
    {
        // 开关面板
        path: '/SPS-012A',
        component: ()=>import('@/views/panel/switch-panel-setting')
    },
	{
	    // 开关面板
	    path: '/SPS-012B',
	    component: ()=>import('@/views/panel/switch-panel-setting')
	},
    {
        // 开关面板
        path: '/SPS-013A',
        component: ()=>import('@/views/panel/switch-panel-setting')
    },
	{
	    // 开关面板
	    path: '/SPS-013B',
	    component: ()=>import('@/views/panel/switch-panel-setting')
	},
	{
	    // 场景开关面板
	    path: '/SPP-012B',
	    component: ()=>import('@/views/panel/spp-01xb')
	},
	{
	    // 场景开关面板
	    path: '/SPP-014B',
	    component: ()=>import('@/views/panel/spp-01xb')
	},
	{
	    // 场景开关面板
	    path: '/SPP-016B',
	    component: ()=>import('@/views/panel/spp-01xb')
	},
	{
	    // 场景开关面板
	    path: '/SPP-018B',
	    component: ()=>import('@/views/panel/spp-01xb')
	},
    {
        // 场景开关面板
        path: '/SPP-036A',
        component: ()=>import('@/views/panel/spp-03xa')
		
    },
	{
	    // 场景开关面板
	    path: '/SPP-032B',
	    component: ()=>import('@/views/panel/spp-03xb')
	},
	{
	    // 场景开关面板
	    path: '/SPP-034B',
	    component: ()=>import('@/views/panel/spp-03xb')
	},
	{
	    // 场景开关面板
	    path: '/SPP-036B',
	    component: ()=>import('@/views/panel/spp-03xb')
	},
	{
	    // 场景开关面板
	    path: '/SPP-038B',
	    component: ()=>import('@/views/panel/spp-03xb')
	},
	{
		//光照传感器
		path: '/SPD-021A',
		component: ()=>import('@/views/sensor/illumination-sensor')
	},
	{
		//光照传感器
		path: '/SPD-021B',
		component: ()=>import('@/views/sensor/illumination-sensor')
	},
	{
		//温湿度传感器
		path: '/SPD-022A',
		component: ()=>import('@/views/sensor/tempAndHum-sensor')
	},
	{
		//温湿度传感器
		path: '/SPD-022B',
		component: ()=>import('@/views/sensor/tempAndHum-sensor')
	},
    {
	// 	//智能面板
        path: '/SPP-040A',
        component: ()=>import('@/views/panel/spp-040041a')
    },
	{
		//智能面板
	    path: '/SPP-041A',
	    component: ()=>import('@/views/panel/spp-040041a')
	},
	{
		//智能面板
	    path: '/SPP-020K',
	    component: ()=>import('@/views/panel/airConditionerpanel')
	},
	{
		//智能面板
	    path: '/IDV-011B',
	    component: ()=>import('@/views/panel/airConditionerpanel')
	},
    {
        path: '/',
        component: ()=>import("@/layout/index.vue"),
        children:[
            
            // {
            //     // 开关面板
            //     path: '/SPS-022A',
            //     component: ()=>import('@/views/panel/switch-panel')
            // }
            
        ]
    }
    
]

export const redirectRoute = [
    {
        path: '/SPL-013A/:pathMatch(.*)*',
        redirect:'/SPL-013A/index'
    },
    {
        path: '/SPL-013B/:pathMatch(.*)*',
        redirect:'/SPL-013B/index'
    },
    {
        path: '/SPL-023A/:pathMatch(.*)*',
        redirect:'/SPL-023A/index'
    },
    {
        path: '/SPL-023B/:pathMatch(.*)*',
        redirect:'/SPL-023B/index'
    },
    {
        path: '/SPL-025A/:pathMatch(.*)*',
        redirect:'/SPL-025A/index'
    },
	//add
	// {
	//     path: '/properties-view/:pathMatch(.*)*',
	//     redirect:'/properties-view/index'
	// },
	//add
    {
        path: '/SPL-025B/:pathMatch(.*)*',
        redirect:'/SPL-025B/index'
    },
    {
        path: '/SPL-031C/:pathMatch(.*)*',
        redirect:'/SPL-031C/index'
    },
    {
        path: '/SPL-032C/:pathMatch(.*)*',
        redirect:'/SPL-032C/index'
    },
    {
        path: '/SPL-033C/:pathMatch(.*)*',
        redirect:'/SPL-033C/index'
    },
	{
	    path: '/SGL-031:pathMatch(.)',
	    redirect:'/SGL-031A'
	},
]

const router = createRouter({
    history: createWebHashHistory(),
    routes:constantRoutes.concat(controllerRoute)
        .concat(gatewayRoute)
        .concat(panelRoute)
        .concat(redirectRoute)
});
router.beforeEach((to,from,next)=>{
	  let userAgent = navigator.userAgent;
	  if (/miniProgram/i.test(userAgent) && /micromessenger/i.test(userAgent) && window.miniImsp) {
		  
		  let [language,region] = window.miniImsp.language.split('-');
		  setCookie({language,region}).then((res)=>{
			  console.log(res);
			  next()
		  }).catch((err)=>{
			  console.log(err)
		  })
		  
	  }else{
		  next()
	  }
  });

export default router;